/**************************************************
 * Nombre:       Apartado_Texto_Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {TrendingFlat} from '@mui/icons-material'
import iso from '../../Recursos/iso.svg'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";


const Apartado_Texto_Boton = ({item, click, termino}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: sCell ? 24 : 24,
                                fontWeight: 600,
                                color: '#fff',
                                textTransform: 'uppercase',
                                lineHeight: 1.2
                            }}>
                                {item.tituloParrafo} <span
                                style={{color: '#9049F5'}}> {item.rosadoTitulo} </span>
                                {item.blancoTitulo} <span
                                style={{color: theme.palette.secondary.main}}> {item.celesteTitulo}</span>
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{color: "#fff", fontStyle: 'italic', fontWeight: 300, fontSize: 14}}>
                                {item.parrafo}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Button
                                onClick={() => click()}
                                sx={{
                                    borderRadius: '30px',
                                    background: 'linear-gradient(102deg, #9049F5 0%, #7A1CFF 100%)',
                                    boxShadow: '0 8px 30px 0 rgba(144, 73, 245, 0.50)',
                                    px: 3,
                                    py: 1,
                                    // Animación condicional basada en el estado
                                    animation: termino ? 'shakeWithPause 3s cubic-bezier(.36,.07,.19,.97) infinite' : 'none',
                                    '@keyframes shakeWithPause': {
                                        // --- FASE DE SHAKE (0% al 30% del tiempo total: ~0.5s) ---
                                        '0%, 30%': {
                                            transform: 'translate3d(0, 0, 0)',
                                        },
                                        '3%, 27%': {
                                            transform: 'translate3d(-1px, 0, 0)',
                                        },
                                        '6%, 24%': {
                                            transform: 'translate3d(2px, 0, 0)',
                                        },
                                        '9%, 15%, 21%': {
                                            transform: 'translate3d(-4px, 0, 0)',
                                        },
                                        '12%, 18%': {
                                            transform: 'translate3d(4px, 0, 0)',
                                        },
                                        // --- FASE DE PAUSA (30% al 100% del tiempo total: ~1.3s) ---
                                        '31%, 100%': {
                                            transform: 'translate3d(0, 0, 0)',
                                        },
                                    },
                                }}
                                endIcon={<TrendingFlat/>}
                            >
                                {item && item.numero && item.numero === 3 ?
                                    'REGISTRARME'
                                    :
                                    'CONTINUAR'
                                }

                            </Button>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{color: "#fff", fontStyle: 'italic', fontWeight: 300, fontSize: 12}}>
                                Termina este video antes de continuar con el siguiente, obtendras mejores resultados
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: -18}}>
                            <img src={iso} width={160} height={'auto'}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Apartado_Texto_Boton